import React from 'react';
import { WithTranslation, withTranslation } from '@wix/wix-i18n-config';
import s from './ErrorComponent.scss';
import errorBg from '../../assets/images/error-bg.jpg';
import wixLogo from '../../assets/images/wix-black-logo.svg?url';
import mobileError from '../../assets/icons/mobileError.svg?url';
import { refreshPage } from '../../services/window-utils';
import { Text } from '@wix/design-system';
import {
  ERR_MSG_GENERAL,
  ERR_MSG_NOT_AUTH,
  ERR_TITLE_GENERAL,
  ERR_TITLE_NOT_AUTH,
} from '../../constants';

export interface ErrorComponentProps extends WithTranslation {
  hostname: string;
  customErrorText: string;
  isMobile: boolean;
}

class ErrorComponent extends React.Component<ErrorComponentProps> {
  renderDesktopError = (titleForUser: string, errorToPresent: string) => {
    const { t, hostname } = this.props;

    return (
      <div data-hook="error-component">
        <div className={s.errorHeaderContainer}>
          <div className={s.errorHeader}>
            <a
              href={`//${hostname}/?utm_campaign=vir_error_page`}
              data-hook="wix-logo"
            >
              <img src={wixLogo} alt="Wix Log" />
            </a>
            <div className={s.buttonsContainer}>
              <a
                className={s.headerLink}
                data-hook="template-button"
                href={`//${hostname}/website/templates/?utm_campaign=vir_error_page`}
              >
                <div>{t('error.templates_button_label')}</div>
              </a>
              <a
                className={s.headerLink}
                data-hook="wix-account-button"
                href={`//${hostname}/?utm_campaign=vir_error_page`}
              >
                <div>{t('error.wix_button_label')}</div>
              </a>
            </div>
          </div>
        </div>
        <div className={s.errorContainer}>
          <img
            className={s.bgImage}
            data-hook="background-image"
            src={errorBg}
            alt="Ascend Package Picker Error"
          />
          <div className={s.errorDescription} data-hook="error-message">
            <h2 className={s.errorTitle}>{t(titleForUser)}</h2>
            <Text size="medium" weight="thin">
              {t(errorToPresent)}
            </Text>
          </div>
        </div>
      </div>
    );
  };

  renderMobileError = (titleForUser: string, errorToPresent: string) => {
    const { t } = this.props;

    return (
      <div
        className={s.mobileErrorComponent}
        data-hook="mobile-error-component"
      >
        <img
          className={s.logo}
          src={mobileError}
          alt="Error"
          data-hook="mobile-error-svg"
        />
        <h2 className={s.mobileTitle} data-hook="mobile-title">
          {t(titleForUser)}
        </h2>
        <div className={s.mobileMessage} data-hook="mobile-message">
          {t(errorToPresent)}
        </div>
        <button
          className={s.refreshBtn}
          data-hook="refresh-btn"
          onClick={() => refreshPage()}
        >
          {t('error.mobileRefreshBtn')}
        </button>
      </div>
    );
  };

  render() {
    const { isMobile, customErrorText } = this.props;
    const ErrorsForUser = [ERR_MSG_NOT_AUTH];
    const GeneralErrorForUser = ERR_MSG_GENERAL;

    const isThePropsMessageIsForUser = ErrorsForUser.includes(customErrorText);
    const titleForUser = isThePropsMessageIsForUser
      ? ERR_TITLE_NOT_AUTH
      : ERR_TITLE_GENERAL;
    const errorForUser = isThePropsMessageIsForUser
      ? customErrorText
      : GeneralErrorForUser;
    if (!isThePropsMessageIsForUser) {
      console.error(customErrorText);
    }

    return isMobile
      ? this.renderMobileError(titleForUser, errorForUser)
      : this.renderDesktopError(titleForUser, errorForUser);
  }
}

export default withTranslation()(ErrorComponent);
